import { render, staticRenderFns } from "./LoginTransit.vue?vue&type=template&id=312eb04c&scoped=true&"
import script from "./LoginTransit.vue?vue&type=script&lang=js&"
export * from "./LoginTransit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312eb04c",
  null
  
)

export default component.exports